import domain from "@/environment";
import axios from "axios";

const state = {
  documentCategories: [],
  documentCategoriesLoading: false,
  documentCategoriesTotal: 0,
};

const getters = {
  getDocumentCategories: (state) => state.documentCategories,
  getDocumentCategoriesLoading: (state) => state.documentCategoriesLoading,
  getDocumentCategoriesTotal: (state) => state.documentCategoriesTotal,
};

const mutations = {
  SET_DOCUMENT_CATEGORIES(state, payload) {
    state.documentCategories = Array.isArray(payload) ? payload : [];
  },
  SET_DOCUMENT_CATEGORIES_LOADING(state, payload) {
    state.documentCategoriesLoading = payload || false;
  },
  SET_DOCUMENT_CATEGORIES_TOTAL(state, payload) {
    state.documentCategoriesTotal = payload || 0;
  },
};

const actions = {
  /**
   * GET /api/document-categories - Liste des catégories de documents
   */
  async fetchDocumentCategories({ commit }, payload = {}) {
    commit("SET_DOCUMENT_CATEGORIES_LOADING", true);
    const params = {};
    if (payload.page) params.page = payload.page;
    if (payload.per_page) params.per_page = payload.per_page;
    if (payload.search) params.search = payload.search;
    try {
      const response = await axios.get(domain + "/document-categories", {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
        params,
      });
      const data = response.data?.data ?? response.data;
      const list = Array.isArray(data) ? data : (data?.data ?? []);
      const total = data?.total ?? list.length;
      commit("SET_DOCUMENT_CATEGORIES", list);
      commit("SET_DOCUMENT_CATEGORIES_TOTAL", total);
      commit("SET_DOCUMENT_CATEGORIES_LOADING", false);
      return { data: list, total };
    } catch (error) {
      commit("SET_DOCUMENT_CATEGORIES_LOADING", false);
      throw error.response?.data?.message ?? error.message;
    }
  },

  /**
   * GET /api/document-categories/{id} - Afficher une catégorie
   */
  async fetchDocumentCategoryById({ commit }, id) {
    commit("SET_DOCUMENT_CATEGORIES_LOADING", true);
    try {
      const response = await axios.get(domain + "/document-categories/" + id, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      const data = response.data?.data ?? response.data;
      commit("SET_DOCUMENT_CATEGORIES_LOADING", false);
      return data;
    } catch (error) {
      commit("SET_DOCUMENT_CATEGORIES_LOADING", false);
      throw error.response?.data?.message ?? error.message;
    }
  },

  /**
   * POST /api/document-categories - Créer une catégorie
   */
  async createDocumentCategory({ commit }, payload) {
    commit("SET_DOCUMENT_CATEGORIES_LOADING", true);
    try {
      const response = await axios.post(domain + "/document-categories", payload, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      const data = response.data?.data ?? response.data;
      commit("SET_DOCUMENT_CATEGORIES_LOADING", false);
      return data;
    } catch (error) {
      commit("SET_DOCUMENT_CATEGORIES_LOADING", false);
      throw error.response?.data?.message ?? error.message;
    }
  },

  /**
   * PUT /api/document-categories/{id} - Modifier une catégorie
   */
  async updateDocumentCategory({ commit }, { id, ...payload }) {
    commit("SET_DOCUMENT_CATEGORIES_LOADING", true);
    try {
      const response = await axios.put(domain + "/document-categories/" + id, payload, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      const data = response.data?.data ?? response.data;
      commit("SET_DOCUMENT_CATEGORIES_LOADING", false);
      return data;
    } catch (error) {
      commit("SET_DOCUMENT_CATEGORIES_LOADING", false);
      throw error.response?.data?.message ?? error.message;
    }
  },

  /**
   * DELETE /api/document-categories/{id} - Supprimer une catégorie
   */
  async deleteDocumentCategory({ commit }, id) {
    commit("SET_DOCUMENT_CATEGORIES_LOADING", true);
    try {
      await axios.delete(domain + "/document-categories/" + id, {
        headers: {
          Authorization: `Bearer ` + this.state.token,
        },
      });
      commit("SET_DOCUMENT_CATEGORIES_LOADING", false);
      return true;
    } catch (error) {
      commit("SET_DOCUMENT_CATEGORIES_LOADING", false);
      throw error.response?.data?.message ?? error.message;
    }
  },
};

export default { state, mutations, getters, actions };
